import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsersFeatureKey } from './users-feature-key';
import { UsersState } from './users.state';

export const UsersFeatureSelector =
  createFeatureSelector<UsersState>(UsersFeatureKey);
// All Users
export const allUsersSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.allUsers;
  }
);
// All Users
export const isAdminSelector = createSelector(UsersFeatureSelector, (state) => {
  return state.isAdmin;
});
// Confirm Account
export const confirmAccountSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.confirmAccount;
  }
);
// Send Link
export const sendLinkSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.sendLink;
  }
);
// Reset Password User Data
export const resetPasswordCodeSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.resetPasswordCode;
  }
);
// Reset Password User Data
export const resetPasswordEmailSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.resetPasswordEmail;
  }
);
// Forgot Password
export const forgotPasswordSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.forgotPassword;
  }
);
// Send Link
export const updateUserSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.updateUser;
  }
);
// Send Link
export const resetPasswordSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.resetPassword;
  }
);
// Send Link
export const deleteUserSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.deleteUser;
  }
);
// Upload File
export const uploadFileSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.uploadFile;
  }
);
// Count
export const usersCountSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.usersCount;
  }
);
// Details
export const userDetailsSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.userDetails;
  }
);
// Details
export const updateCompanyManagerSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.updateCompanyManager;
  }
);

/**
 * All Users Selector
 */
export const allUsersSuccessSelector = createSelector(
  allUsersSelector,
  (state) => {
    return state.data;
  }
);
export const allUsersFailureSelector = createSelector(
  allUsersSelector,
  (state) => {
    return state.failure;
  }
);
export const allUsersLoadingSelector = createSelector(
  allUsersSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Send Link Selector
 */
export const sendLinkSuccessSelector = createSelector(
  sendLinkSelector,
  (state) => {
    return state.data;
  }
);
export const sendLinkFailureSelector = createSelector(
  sendLinkSelector,
  (state) => {
    return state.failure;
  }
);
export const sendLinkLoadingSelector = createSelector(
  sendLinkSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Upload File Selector
 */
export const uploadFileSuccessSelector = createSelector(
  uploadFileSelector,
  (state) => {
    return state.data;
  }
);
export const uploadFileFailureSelector = createSelector(
  uploadFileSelector,
  (state) => {
    return state.failure;
  }
);
export const uploadFileLoadingSelector = createSelector(
  uploadFileSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Users Count Selector
 */
export const usersCountSuccessSelector = createSelector(
  usersCountSelector,
  (state) => {
    return state.data;
  }
);
export const usersCountFailureSelector = createSelector(
  usersCountSelector,
  (state) => {
    return state.failure;
  }
);
export const usersCountLoadingSelector = createSelector(
  usersCountSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Users Details Selector
 */
export const userDetailsSuccessSelector = createSelector(
  userDetailsSelector,
  (state) => {
    return state.data;
  }
);
export const userDetailsFailureSelector = createSelector(
  userDetailsSelector,
  (state) => {
    return state.failure;
  }
);
export const userDetailsLoadingSelector = createSelector(
  userDetailsSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Users Update Selector
 */
export const updateUserSuccessSelector = createSelector(
  updateUserSelector,
  (state) => {
    return state.data;
  }
);
export const updateUserFailureSelector = createSelector(
  updateUserSelector,
  (state) => {
    return state.failure;
  }
);
export const updateUserLoadingSelector = createSelector(
  updateUserSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Users Delete Selector
 */
export const deleteUserSuccessSelector = createSelector(
  deleteUserSelector,
  (state) => {
    return state.data;
  }
);
export const deleteUserFailureSelector = createSelector(
  deleteUserSelector,
  (state) => {
    return state.failure;
  }
);
export const deleteUserLoadingSelector = createSelector(
  deleteUserSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Forgot Password Selector
 */
export const forgotPasswordSuccessSelector = createSelector(
  forgotPasswordSelector,
  (state) => {
    return state.data;
  }
);
export const forgotPasswordFailureSelector = createSelector(
  forgotPasswordSelector,
  (state) => {
    return state.failure;
  }
);
export const forgotPasswordLoadingSelector = createSelector(
  forgotPasswordSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Reset Password Selector
 */
export const resetPasswordSuccessSelector = createSelector(
  resetPasswordSelector,
  (state) => {
    return state.data;
  }
);
export const resetPasswordFailureSelector = createSelector(
  resetPasswordSelector,
  (state) => {
    return state.failure;
  }
);
export const resetPasswordLoadingSelector = createSelector(
  resetPasswordSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Reset Password Selector
 */
export const updateCompanyManagerSuccessSelector = createSelector(
  updateCompanyManagerSelector,
  (state) => {
    return state.data;
  }
);
export const updateCompanyManagerFailureSelector = createSelector(
  updateCompanyManagerSelector,
  (state) => {
    return state.failure;
  }
);
export const updateCompanyManagerLoadingSelector = createSelector(
  updateCompanyManagerSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Reset Password Selector
 */
export const confirmAccountSuccessSelector = createSelector(
  confirmAccountSelector,
  (state) => {
    return state.data;
  }
);
export const confirmAccountFailureSelector = createSelector(
  confirmAccountSelector,
  (state) => {
    return state.failure;
  }
);
export const confirmAccountLoadingSelector = createSelector(
  confirmAccountSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Create Company Manager Selector
 */
export const createCompanyManagerSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.createCompanyManager;
  }
);
export const createCompanyManagerSuccessSelector = createSelector(
  createCompanyManagerSelector,
  (state) => {
    return state.data;
  }
);
export const createCompanyManagerFailureSelector = createSelector(
  createCompanyManagerSelector,
  (state) => {
    return state.failure;
  }
);
export const createCompanyManagerLoadingSelector = createSelector(
  createCompanyManagerSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Resend Email Selector
 */
export const resendEmailSelector = createSelector(
  UsersFeatureSelector,
  (state) => {
    return state.resendEmail;
  }
);
export const resendEmailSuccessSelector = createSelector(
  resendEmailSelector,
  (state) => {
    return state.data;
  }
);
export const resendEmailFailureSelector = createSelector(
  resendEmailSelector,
  (state) => {
    return state.failure;
  }
);
export const resendEmailLoadingSelector = createSelector(
  resendEmailSelector,
  (state) => {
    return state.loading;
  }
);
